import { get as e } from "theme-ui";
import { keyframes as n } from "@emotion/react";
const o = n({
  from: { transform: "translateX(-100%)" },
  to: { transform: "translateX(100%)" }
}), r = {
  base: {
    position: "relative",
    overflow: "hidden",
    bg: "secondary",
    color: "transparent",
    userSelect: "none",
    transition: (t) => `${e(t, "transitions.all")}, color 0ms`,
    "*": {
      visibility: "hidden",
      transition: "none"
    },
    "::after": {
      content: '""',
      position: "absolute",
      top: 0,
      left: 0,
      height: "100%",
      width: "100%",
      background: "linear-gradient(90deg, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.6),  rgba(255, 255, 255, 0))",
      animation: `${o} 1.25s infinite`
    }
  },
  text: {
    variant: "skeletons.base",
    display: "inline-flex",
    borderRadius: "xs"
  }
}, a = {
  skeletons: r
};
export {
  a as skeletonsTheme
};
